// extracted by mini-css-extract-plugin
module.exports = {"itemWrapper":"styles_itemWrapper__i2cX5","listItem":"styles_listItem__ePHTx"};